import _defineProperty2 from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _Reflect$construct from "@babel/runtime-corejs3/core-js-stable/reflect/construct";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import _classCallCheck from "@babel/runtime-corejs3/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/createClass";
import _assertThisInitialized from "@babel/runtime-corejs3/helpers/assertThisInitialized";
import _get from "@babel/runtime-corejs3/helpers/get";
import _inherits from "@babel/runtime-corejs3/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs3/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs3/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _Object$assign from "@babel/runtime-corejs3/core-js-stable/object/assign";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/reduce";
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = _Reflect$construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !_Reflect$construct) return false;
  if (_Reflect$construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Date.prototype.toString.call(_Reflect$construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import constant from "lodash/constant";
import assignWith from "lodash/assignWith";
import memoize from 'memoize-one';
import { intlMessageShape, availableValuesIdDisplayNameObject, DATA_TYPE_OBJECT } from '@jutro/prop-types';
import { messages } from './LookupField.messages';
import { FieldComponent } from '../FieldComponent/FieldComponent';
import { GenericSelectControl } from '../GenericSelectControl/GenericSelectControl';
import { LookupOption as Option } from './components/LookupOption';
import { LookupValue as Value } from './components/LookupValue';
import { LookupDropdownIndicator as DropdownIndicator } from './components/LookupDropdownIndicator';
import { LookupClearIndicator as ClearIndicator } from './components/LookupClearIndicator';
import { LookupControl as Control } from './components/LookupControl';
import { LookupMenu as Menu } from './components/LookupMenu';
import { LookupPlaceholder as Placeholder } from './components/LookupPlaceholder';
import styles from "./LookupField.module.css";
var lookupComponents = {
  Option: Option,
  Value: Value,
  DropdownIndicator: DropdownIndicator,
  ClearIndicator: ClearIndicator,
  Control: Control,
  Menu: Menu,
  Placeholder: Placeholder
};
var shouldCreateNew = function shouldCreateNew(text) {
  return !!text;
};
var FALSE = constant(false);
var getOptionTypesMap = memoize(function () {
  var optionTypes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return _reduceInstanceProperty(optionTypes).call(optionTypes, function (map, _ref) {
    var type = _ref.type,
      icon = _ref.icon,
      className = _ref.className,
      displayName = _ref.displayName;
    return _Object$assign(map, _defineProperty2({}, type, {
      icon: icon,
      className: className,
      displayName: displayName
    }));
  }, {});
});
var getMergedStyles = memoize(function (internalClassNames) {
  return internalClassNames ? assignWith(_objectSpread({}, styles), internalClassNames, function (lookupFieldStyle, additionalStyle) {
    return additionalStyle ? cx(lookupFieldStyle, additionalStyle) : lookupFieldStyle;
  }) : styles;
});
var LookupOptionShape = PropTypes.shape(_objectSpread({}, availableValuesIdDisplayNameObject, {
  type: PropTypes.string.isRequired
}));
export var LookupField = function (_FieldComponent) {
  _inherits(LookupField, _FieldComponent);
  var _super = _createSuper(LookupField);
  function LookupField() {
    var _this;
    _classCallCheck(this, LookupField);
    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(_args));
    _defineProperty(_assertThisInitialized(_this), "handleValueChange", function (value) {
      _this.beforeValue = _this.props.value;
      _this.notifyChange(value);
    });
    _defineProperty(_assertThisInitialized(_this), "recent", _this.props.onLoadValues ? [] : _this.props.availableValues);
    _defineProperty(_assertThisInitialized(_this), "state", {
      recent: _this.recent
    });
    _defineProperty(_assertThisInitialized(_this), "loadValues", function (onLoadValues) {
      return function _callee() {
        var _args2 = arguments;
        return _regeneratorRuntime().async(function _callee$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _regeneratorRuntime().awrap(onLoadValues.apply(void 0, _args2));
            case 2:
              _this.recent = _context2.sent;
              return _context2.abrupt("return", _this.recent);
            case 4:
            case "end":
              return _context2.stop();
          }
        }, null, null, null, Promise);
      };
    });
    _defineProperty(_assertThisInitialized(_this), "onMenuClose", function () {
      _this.setState({
        recent: _this.recent
      });
    });
    return _this;
  }
  _createClass(LookupField, [{
    key: "renderControlReadOnly",
    value: function renderControlReadOnly(breakpointProps) {
      var id = breakpointProps.id,
        value = breakpointProps.value,
        optionTypes = breakpointProps.optionTypes,
        className = breakpointProps.className;
      var optionTypesMap = getOptionTypesMap(optionTypes);
      var mergedStyles = getMergedStyles(this.props.internalClassNames);
      return value && React.createElement("div", {
        id: id,
        "data-read-only": true,
        className: cx(mergedStyles.lookupField, className)
      }, React.createElement(lookupComponents.Value, {
        data: value,
        selectProps: {
          customStyles: mergedStyles,
          optionTypesMap: optionTypesMap
        }
      }));
    }
  }, {
    key: "renderControl",
    value: function renderControl(breakpointProps, _ref2) {
      var isValid = _ref2.isValid,
        labelId = _ref2.labelId;
      var id = breakpointProps.id,
        availableValues = breakpointProps.availableValues,
        className = breakpointProps.className,
        createNewMessage = breakpointProps.createNewMessage,
        isClearable = breakpointProps.isClearable,
        onLoadValues = breakpointProps.onLoadValues,
        onAddNew = breakpointProps.onAddNew,
        optionTypes = breakpointProps.optionTypes,
        placeholder = breakpointProps.placeholder,
        value = breakpointProps.value,
        disabled = breakpointProps.disabled,
        isInitiallyOpen = breakpointProps.isInitiallyOpen,
        internalClassNames = breakpointProps.internalClassNames;
      var mergedStyles = getMergedStyles(internalClassNames);
      var classes = cx(mergedStyles.lookupField, className);
      var allowNewValue = onAddNew ? shouldCreateNew : FALSE;
      return React.createElement(GenericSelectControl, {
        id: id,
        availableValues: availableValues,
        className: classes,
        components: lookupComponents,
        createNewMessage: createNewMessage,
        defaultOptions: this.state.recent,
        disabled: disabled,
        filter: lookupFilter,
        getOptionValue: getOptionValue,
        getOptionLabel: getOptionLabel,
        isClearable: isClearable,
        allowNewValue: allowNewValue,
        labelId: labelId,
        loadValues: onLoadValues ? this.loadValues(onLoadValues) : undefined,
        onAddNew: onAddNew,
        onBlur: this.handleBlur,
        onFocus: this.handleFocus,
        onInputChange: this.onInputChange,
        onMenuClose: this.onMenuClose,
        onValueChange: this.handleValueChange,
        placeholder: placeholder,
        valid: isValid,
        value: value,
        optionTypesMap: getOptionTypesMap(optionTypes),
        customStyles: mergedStyles,
        showRecent: !!onLoadValues,
        isInitiallyOpen: isInitiallyOpen
      });
    }
  }, {
    key: "render",
    value: function render() {
      return _get(_getPrototypeOf(LookupField.prototype), "render", this).call(this);
    }
  }]);
  return LookupField;
}(FieldComponent);
_defineProperty(LookupField, "propTypes", _objectSpread({}, FieldComponent.propTypes, {
  availableValues: PropTypes.arrayOf(LookupOptionShape),
  optionTypes: PropTypes.arrayOf(PropTypes.shape({
    type: PropTypes.string.isRequired,
    icon: PropTypes.string.isRequired,
    className: PropTypes.string,
    displayName: intlMessageShape.isRequired
  })),
  createNewMessage: intlMessageShape,
  defaultValue: LookupOptionShape,
  isClearable: PropTypes.bool,
  onLoadValues: PropTypes.func,
  onAddNew: PropTypes.func,
  value: LookupOptionShape,
  isInitiallyOpen: PropTypes.bool,
  internalClassNames: PropTypes.object
}));
_defineProperty(LookupField, "defaultProps", _objectSpread({}, FieldComponent.defaultProps, {
  createNewMessage: messages.addItem,
  isClearable: true,
  dataType: DATA_TYPE_OBJECT
}));
function lookupFilter(_ref3, text) {
  var displayName = _ref3.displayName;
  var _context;
  return displayName === null || displayName === void 0 ? void 0 : _includesInstanceProperty(_context = displayName.toLowerCase()).call(_context, text.toLowerCase());
}
function getOptionValue(_ref4) {
  var id = _ref4.id;
  return id;
}
function getOptionLabel(_ref5) {
  var displayName = _ref5.displayName;
  return displayName;
}
LookupField.__docgenInfo = {
  componentName: "LookupField",
  packageName: "@jutro/components",
  description: "",
  displayName: "LookupField",
  methods: [{
    name: "handleValueChange",
    docblock: "handle value change\n@param {object} value",
    modifiers: [],
    params: [{
      name: "value",
      description: null,
      type: {
        name: "object"
      },
      optional: false
    }],
    returns: null,
    description: "handle value change"
  }, {
    name: "renderControlReadOnly",
    docblock: null,
    modifiers: [],
    params: [{
      name: "breakpointProps",
      optional: undefined,
      type: null
    }],
    returns: null
  }, {
    name: "renderControl",
    docblock: null,
    modifiers: [],
    params: [{
      name: "breakpointProps",
      optional: undefined,
      type: null
    }, {
      name: "{ isValid, labelId }",
      optional: undefined,
      type: null
    }],
    returns: null
  }, {
    name: "loadValues",
    docblock: null,
    modifiers: [],
    params: [{
      name: "onLoadValues",
      optional: undefined,
      type: null
    }],
    returns: null
  }, {
    name: "onMenuClose",
    docblock: null,
    modifiers: [],
    params: [],
    returns: null
  }],
  actualName: "LookupField",
  metadataType: "field",
  props: {
    availableValues: {
      type: {
        name: "arrayOf",
        value: {
          name: "custom",
          raw: "LookupOptionShape"
        }
      },
      required: false,
      description: "Array of choice objects to display"
    },
    optionTypes: {
      type: {
        name: "arrayOf",
        value: {
          name: "shape",
          value: {
            type: {
              name: "string",
              required: true
            },
            icon: {
              name: "string",
              required: true
            },
            className: {
              name: "string",
              required: false
            },
            displayName: {
              name: "union",
              required: true,
              value: [{
                name: "string"
              }, {
                name: "shape",
                value: {
                  id: {
                    name: "string",
                    required: false
                  },
                  defaultMessage: {
                    name: "string",
                    required: false
                  },
                  args: {
                    name: "shape",
                    value: {},
                    required: false
                  }
                }
              }]
            }
          }
        }
      },
      required: false,
      description: "Description for available option types"
    },
    createNewMessage: {
      type: {
        name: "union",
        value: [{
          name: "string"
        }, {
          name: "shape",
          value: {
            id: {
              name: "string",
              required: false
            },
            defaultMessage: {
              name: "string",
              required: false
            },
            args: {
              name: "shape",
              value: {},
              required: false
            }
          }
        }]
      },
      required: false,
      description: "The message to display when a new options is being created by the user.",
      defaultValue: {
        value: "messages.addItem",
        computed: true
      }
    },
    defaultValue: {
      type: {
        name: "custom",
        raw: "LookupOptionShape"
      },
      required: false,
      description: "Set the default field value on render if there is a default value; needs onValueChange to work"
    },
    isClearable: {
      type: {
        name: "bool"
      },
      required: false,
      description: "If true ClearIndicator will be shown",
      defaultValue: {
        value: "true",
        computed: false
      }
    },
    onLoadValues: {
      type: {
        name: "func"
      },
      required: false,
      description: "Function for asynchronous data loading"
    },
    onAddNew: {
      type: {
        name: "func"
      },
      required: false,
      description: "Callback when new items created"
    },
    value: {
      type: {
        name: "custom",
        raw: "LookupOptionShape"
      },
      required: false,
      description: "Value to display in control"
    },
    isInitiallyOpen: {
      type: {
        name: "bool"
      },
      required: false,
      description: "Should dropdown be initially opened"
    },
    internalClassNames: {
      type: {
        name: "object"
      },
      required: false,
      description: "Map of CSS class names for overriding individual parts of component's styles"
    },
    dataType: {
      defaultValue: {
        value: "DATA_TYPE_OBJECT",
        computed: true
      },
      required: false
    }
  },
  composes: ["../FieldComponent/FieldComponent"]
};